import Vue from 'vue'
import BootstrapVue from "bootstrap-vue"
import App from './App.vue'
import "bootstrap/dist/css/bootstrap.min.css"
import "bootstrap-vue/dist/bootstrap-vue.css"
import VueCarousel from 'vue-carousel'
import vSelect from 'vue-select'
import router from './router'
import VueGtag from "vue-gtag";

import { library } from '@fortawesome/fontawesome-svg-core'
import { faMinusSquare } from '@fortawesome/free-solid-svg-icons'
import { faPlusSquare } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

library.add(faMinusSquare)
library.add(faPlusSquare)
Vue.component('font-awesome-icon', FontAwesomeIcon)

Vue.component('v-select', vSelect)
window.axios = require('axios')
Vue.use(VueCarousel)
Vue.use(BootstrapVue)
Vue.config.productionTip = false

Vue.use(VueGtag, {
  config: { id: "G-GEQWYPV910" }
});

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')